import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star",
  "use": "star-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"star\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.74615 0L7.61664 3.79674L11.5073 4.56591L8.78383 7.69167L9.30757 11.963L5.74615 10.0974L2.1997 11.963L2.72344 7.69167L0 4.56591L3.87566 3.79674L5.74615 0Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol